export const analyticsViewComponentName = 'profileCardNextView';
